export const flatten = (data) =>
  data.reduce(
    (acc, { results, totalItems }) => {
      acc.results = [...acc.results, ...results];
      acc.totalItems = totalItems;
      return acc;
    },
    {
      results: [],
      totalItems: 0,
    },
  );
